
/**
 * Extracts image URLs from markdown content
 */
export function extractImageUrlsFromMarkdown(content: string): string[] {
  const imageRegex = /!\[.*?\]\((.*?)\)/g;
  const urls: string[] = [];
  let match;
  
  console.log('Extracting image URLs from markdown content');
  
  while ((match = imageRegex.exec(content)) !== null) {
    if (match[1]) {
      // Ensure URL has https: prefix if it's a Contentful URL
      let url = match[1];
      if (url.startsWith('//')) {
        url = 'https:' + url;
      }
      urls.push(url);
      console.log('Found image URL:', url);
    }
  }
  
  // Also look for contentful-image references
  const contentfulImageRegex = /\[contentful-image:([\w-]+)\]/g;
  while ((match = contentfulImageRegex.exec(content)) !== null) {
    const assetId = match[1];
    console.log('Found contentful-image reference:', assetId);
    // We'll handle these in the ContentRenderer component
  }
  
  return urls;
}

/**
 * Validates an image URL and ensures it has the correct protocol
 */
export function validateImageUrl(url: string): string {
  if (!url) return '';
  
  // Add https: prefix if needed
  if (url.startsWith('//')) {
    return 'https:' + url;
  }
  
  // Ensure URL has a protocol
  if (!url.startsWith('http') && !url.startsWith('/')) {
    return 'https://' + url;
  }
  
  return url;
}

/**
 * Adds Contentful image optimization parameters if needed
 */
export function optimizeContentfulImage(url: string, width = 1200, height = 800): string {
  if (!url) return '';
  
  // Ensure we have a valid URL first
  url = validateImageUrl(url);
  
  // Add image optimization parameters for Contentful
  if (url.includes('images.ctfassets.net')) {
    // Only add parameters if they're not already there
    const hasParams = url.includes('?');
    if (!hasParams) {
      url += `?w=${width}&h=${height}&fit=fill`;
    }
  }
  
  return url;
}

/**
 * Inserts images into content at specific paragraph positions
 */
export function insertImagesIntoContent(content: string, images: string[]): string {
  // This function is no longer used for automatic insertion
  // We'll only use explicit image references from Contentful
  return content;
}
